import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["disabled", "inverse", "colors", "size", "className", "indeterminate", "onClick", "children", "checked", "clsPrefix", "onDoubleClick", "style", "onChange"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import omit from "omit.js";
var propTypes = {
  colors: PropTypes.oneOf(['', 'dark', 'success', 'info', 'warning', 'danger', 'primary']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  inverse: PropTypes.bool,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onChange: PropTypes.func,
  antd: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  value: PropTypes.string,
  style: PropTypes.object,
  indeterminate: PropTypes.bool
};
var defaultProps = {
  className: '',
  disabled: false,
  inverse: false,
  colors: 'primary',
  checked: undefined,
  defaultChecked: false,
  onClick: function onClick() {},
  onDoubleClick: null,
  onChange: function onChange() {},
  style: {},
  antd: false,
  value: '',
  indeterminate: false
};
var Checkbox = (_dec = WebUI({
  name: "checkbox",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(_props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "changeState", function (e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var checked = _this.state.checked;
      clearTimeout(_this.doubleClickFlag);
      /*if(props.onClick instanceof Function){
          props.onClick(e);
      }*/

      if (props.onDoubleClick instanceof Function) {
        _this.doubleClickFlag = setTimeout(function () {
          //do function在此处写单击事件要执行的代码
          _this.change(props, checked, e);
        }, 300);
      } else {
        _this.change(props, checked, e);
      }

      e.stopPropagation();
      e.preventDefault(); //执行延时
    });

    _defineProperty(_assertThisInitialized(_this), "change", function (props) {
      var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var event = arguments.length > 2 ? arguments[2] : undefined;

      if (props.disabled) {
        return;
      }

      if (!('checked' in props) || props.checked === undefined) {
        _this.setState({
          checked: !checked
        });
      }

      if (props.onChange instanceof Function) {
        if (props.antd) {
          event.target.checked = !checked;
          props.onChange(event);
        } else {
          props.onChange(!checked);
        }
      }

      if (props.onClick instanceof Function) {
        event.target.checked = !checked;
        props.onClick(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handledbClick", function (e) {
      var onDoubleClick = _this.props.onDoubleClick;
      clearTimeout(_this.doubleClickFlag);
      onDoubleClick && onDoubleClick(_this.state.checked, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      if (e.target && e.target.type == 'checkbox') {
        _this.setState({
          focused: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      if (e.target && e.target.type == 'checkbox') {
        _this.setState({
          focused: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      if (e.target && e.target.type == 'checkbox') {
        _this.setState({
          hovered: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (e) {
      if (e.target && e.target.type == 'checkbox') {
        _this.setState({
          hovered: false
        });
      }
    });

    _this.state = {
      checked: 'checked' in _props ? !!_props.checked : _props.defaultChecked,
      focused: false,
      hovered: false
    };
    _this.doubleClickFlag = null;
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          inverse = _this$props.inverse,
          colors = _this$props.colors,
          size = _this$props.size,
          className = _this$props.className,
          indeterminate = _this$props.indeterminate,
          onClick = _this$props.onClick,
          children = _this$props.children,
          checked = _this$props.checked,
          clsPrefix = _this$props.clsPrefix,
          onDoubleClick = _this$props.onDoubleClick,
          style = _this$props.style,
          onChange = _this$props.onChange,
          others = _objectWithoutProperties(_this$props, _excluded);

      var input = /*#__PURE__*/React.createElement("input", _extends({}, omit(others, ["antd"]), {
        type: "checkbox",
        disabled: this.props.disabled,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }));
      var classes = (_classes = {}, _defineProperty(_classes, "".concat(clsPrefix, "-focused"), this.state.focused), _defineProperty(_classes, "".concat(clsPrefix, "-hovered"), this.state.hovered), _defineProperty(_classes, 'is-checked', this.state.checked), _defineProperty(_classes, "disabled", disabled), _classes);

      if (inverse) {
        classes["".concat(clsPrefix, "-inverse")] = true;
      }

      if (colors) {
        classes["".concat(clsPrefix, "-").concat(colors)] = true;
      }

      if (size) {
        classes["".concat(clsPrefix, "-").concat(size)] = true;
      }

      if (!checked && indeterminate) {
        classes["".concat(clsPrefix, "-indeterminate")] = true;
      }

      var classNames = classnames(clsPrefix, classes);
      return /*#__PURE__*/React.createElement("label", {
        className: classnames(classNames, className),
        onDoubleClick: this.handledbClick,
        style: style,
        onClick: this.changeState
      }, input, /*#__PURE__*/React.createElement("label", {
        className: clsPrefix + '-label'
      }, children));
    }
  }]);

  return Checkbox;
}(React.Component)) || _class);
Checkbox.propTypes = propTypes;
export default Checkbox;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-checkbox/src/Checkbox.js